import { render, staticRenderFns } from "./callHistory.vue?vue&type=template&id=c2835442&scoped=true"
import script from "./callHistory.vue?vue&type=script&lang=js"
export * from "./callHistory.vue?vue&type=script&lang=js"
import style0 from "./callHistory.vue?vue&type=style&index=0&id=c2835442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2835442",
  null
  
)

export default component.exports